async function watchProgress(response: Response, progressCallback: (percentage: number, retries: number) => void, retries: number) {
  if (!response.body || !response.headers) return;
  let reader = response.body.getReader();

  const contentLength = Number(response.headers.get('Content-Length')) || 0;
  let receivedLength = 0;

  const processChunk = (value: Uint8Array | undefined) => {
    receivedLength += value?.length || 0;
    const percentage = Math.floor((receivedLength / contentLength) * 100);
    progressCallback(percentage, retries);
  };

  const readWithTimeout = async (): Promise<ReadableStreamReadResult<Uint8Array>> => {
    try {
      const timeoutId = setTimeout(() => {
        reader.releaseLock();
      }, 1000);
      const result = await reader.read();
      clearTimeout(timeoutId);
      return result;
    } catch (error) {
      console.error('Error reading stream:', receivedLength);
      // reader = response.body.getReader(); // Get a new reader
      throw error; // Re-throw to be caught in the main loop
    }
  };

  while (true) {
    const { done, value } = await readWithTimeout();

    if (done) {
      break;
    }

    processChunk(value);
  }
}

async function fetchBlob(
  url: string,
  progressCallback: (percentage: number, retries: number) => void,
  requestInit?: RequestInit,
): Promise<Blob> {
  // Fetch the resource
  let response = await fetch(url, requestInit)
  let retries = 0;

  if (response.status >= 400) {
    throw new Error(`Failed to fetch ${url}: ${response.status} (${response.statusText})`)
  }

  while(retries < 5){
    try {
      await watchProgress(response.clone(), progressCallback, retries)
      break;
    } catch {
      response = await fetch(url, requestInit);
      retries += 1;
    }
  }

  console.log("Sending blob");
  return response.blob()
}

const Fetcher = {
  fetchBlob,
}

export default Fetcher
